interface IViewData {
  headingType: string;
}

export enum EAlertType {
  Favorites = 'favorites',
  Chats = 'chats',
  Hide = 'hide',
}

export interface IOpenAuthModalParameters {
  autoRefresh?: boolean;
  alert?: EAlertType | null;
  useDefaultView?: boolean;
  viewData?: IViewData | null;
  source?: string | null;
}
